import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import { useTranslation } from "react-i18next";
import { NumericFormat } from "react-number-format";

export default function SelectFinancialData({ data, dataChange }) {

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.action.hover,
      borderSpacing: "10px"
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));
  const realonlyField=["backlogGrossProfit"]
  const headColumns = [
    "depreciationAndAmortization",
    "interestExpense",
    "totalBacklog",
    "backlogGrossProfit",
    "totalLineOfCredit",
    "lineOfCreditAvailability",
    "totalThreeLargestCompletedProjects"
  ];
  const hiddenheadColumns = [
    
        "totalThreeLargestCompletedProjects"
    ];

  const [currentlyFocused, setCurrentlyFocused] = useState(null);

  const { t } = useTranslation();

  return (
    <div>
      <TableContainer component={Paper}>

        <Table sx={{ minWidth: 700 }} aria-label="customized table">
          <TableHead>
            <TableRow>
              <StyledTableCell>&nbsp;</StyledTableCell>
              <StyledTableCell align="right" className='text-muted'>{('Current YTD')}</StyledTableCell>
              <StyledTableCell align="right" className='text-muted'>{('Previous Year')} </StyledTableCell>
              <StyledTableCell align="right" className='text-muted'>{('2 Years Previous')}</StyledTableCell>
              <StyledTableCell align="right" className='text-muted'>{('3 Years Previous')}&nbsp;</StyledTableCell>

            </TableRow>
          </TableHead>

          {headColumns?.map((r, index) => (
            <TableRow
              key={index}
              sx={{
                backgroundColor:
                  realonlyField.indexOf(r) != -1 ? " #F2F4F7" : "#fff",
              }}
            >
              <StyledTableCell>{t(r)}</StyledTableCell>
              <StyledTableCell align="right" className="text-muted">
                <NumericFormat
                  customInput={TextField}
                  decimalScale={0}
                  thousandSeparator=","
                  autoFocus={`values1${index}` === currentlyFocused}
                  onFocus={() => setCurrentlyFocused(`values1${index}`)}
                  disabled={realonlyField.indexOf(r) != -1}
                  sx={{
                    "& legend": { display: "none" },
                    "& fieldset": { top: 0 },
                  }}
                  size="small"
                  id="outlined-basic"
                  value={data?.[0]?.[r]}
                  variant="outlined"
                  //   onChange={(event) => {
                  //     dataChange(0, r, event.target.value);
                  //   }}
                  onValueChange={(values) => {
                    dataChange(0, r, values.floatValue);
                  }}
                />
              </StyledTableCell>
              <StyledTableCell align="right" className="text-muted">
                <NumericFormat
                  customInput={TextField}
                  decimalScale={0}
                  thousandSeparator=","
                  autoFocus={`values2${index}` === currentlyFocused}
                  onFocus={() => setCurrentlyFocused(`values2${index}`)}
                  disabled={realonlyField.indexOf(r) != -1}
                  size="small"
                  id="outlined-basic"
                  sx={{
                    "& legend": { display: "none" },
                    "& fieldset": { top: 0 },
                  }}
                  value={data?.[1]?.[r]}
                  variant="outlined"
                  //   onChange={(event) => {
                  //     dataChange(1, r, event.target.value);
                  //   }}
                  onValueChange={(values) => {
                    dataChange(1, r, values.floatValue);
                  }}
                  hidden={hiddenheadColumns.indexOf(r) != -1}
                />{" "}
              </StyledTableCell>
              <StyledTableCell align="right" className="text-muted">
                <NumericFormat
                  customInput={TextField}
                  decimalScale={0}
                  thousandSeparator=","
                  autoFocus={`values3${index}` === currentlyFocused}
                  onFocus={() => setCurrentlyFocused(`values3${index}`)}
                  disabled={realonlyField.indexOf(r) != -1}
                  size="small"
                  id="outlined-basic"
                  sx={{
                    "& legend": { display: "none" },
                    "& fieldset": { top: 0 },
                  }}
                  value={data?.[2]?.[r]}
                  variant="outlined"
                  //   onChange={(event) => {
                  //     dataChange(2, r, event.target.value);
                  //   }}
                  onValueChange={(values) => {
                    dataChange(2, r, values.floatValue);
                  }}
                  hidden={hiddenheadColumns.indexOf(r) != -1}
                />
              </StyledTableCell>
              <StyledTableCell align="right" className="text-muted">
                <NumericFormat
                  customInput={TextField}
                  decimalScale={0}
                  thousandSeparator=","
                  autoFocus={`values4${index}` === currentlyFocused}
                  onFocus={() => setCurrentlyFocused(`values4${index}`)}
                  disabled={realonlyField.indexOf(r) != -1}
                  size="small"
                  id="outlined-basic"
                  sx={{
                    "& legend": { display: "none" },
                    "& fieldset": { top: 0 },
                  }}
                  value={data?.[3]?.[r]}
                  variant="outlined"
                  //   onChange={(event) => {
                  //     dataChange(3, r, event.target.value);
                  //   }}
                  onValueChange={(values) => {
                    dataChange(3, r, values.floatValue);
                  }}
                  hidden={hiddenheadColumns.indexOf(r) != -1}
                />
              </StyledTableCell>
            </TableRow>
          ))}
        </Table>
      </TableContainer>

    </div>
  )
}